import { EventBus } from '@/plugins/event-bus'
import ConfigurationApi from 'api-client/Configuration'
import axios from 'axios'

const moduleState = {
  isUpdating: false,
  isKomNumberUpdating: false,
  price: null,
  netCatalogPrice: 0,
  configuration: null,
  configurationCode: '',
  stockCarId: '',
  stockCarDetails: null,
  komNumber: '',
  isLoading: false,
  images: {
    exterior: '',
    extRear: '',
    extSide: '',
    interior: '',
    intBoot: '',
    intSide: '',
  },
}

const getters = {
  price: (state) => state.price,
  netCatalogPrice: (state) => state.netCatalogPrice,
  configuration: (state) => state.configuration,
  cocaId: (state) => state.configuration?.CocaId,
  configurationCode: (state) => state.configurationCode,
  stockCarId: (state) => state.stockCarId,
  stockCarDetails: (state) => state.stockCarDetails,
  isStockCarAvailable: (state) => state.stockCarDetails?.Status !== 'CLOSED',
  komNumber: (state) => state.komNumber,
  isLoading: (state) => state.isLoading,
  isUpdating: (state) => state.isUpdating,
  isKomNumberUpdating: (state) => state.isKomNumberUpdating,
  status: (state) => state.configuration?.Status,
  isConfigurationValid: (state) => state.configuration?.Status?.IsValid,
  isCC2: (state) => state.configuration?.IsCC2,
}

const mutations = {
  /* eslint-disable no-param-reassign */
  setPrice: (state, payload) => {
    state.price = payload
    EventBus.$emit('configuration/price')
  },
  setNetCatalogPrice: (state, payload) => {
    state.netCatalogPrice = payload
    EventBus.$emit('configuration/netCatalogPrice')
  },
  setConfiguration: (state, payload) => {
    state.configuration = payload
    EventBus.$emit('configuration/configuration')
    EventBus.$emit('configuration/status')
  },
  setConfigurationCode: (state, payload) => {
    state.configurationCode = payload
    state.stockCarId = null
    EventBus.$emit('configuration/configurationCode')
  },
  setStockCarId: (state, payload) => {
    state.stockCarId = payload
    state.configurationCode = null
    EventBus.$emit('configuration/stockCarId')
  },
  setStockCarDetails: (state, payload) => {
    state.stockCarDetails = payload
    EventBus.$emit('configuration/stockCarDetails')
  },
  setLoading: (state, payload) => {
    state.isLoading = payload
    EventBus.$emit('configuration/isLoading')
  },
  setKomNumber: (state, payload) => {
    state.komNumber = payload
    EventBus.$emit('configuration/komNumber')
  },
  setImages: (state, payload) => {
    if (payload == null) {
      state.images.interior = ''
      state.images.exterior = ''
      state.images.extRear = ''
      state.images.extSide = ''
      state.images.intBoot = ''
      state.images.intSide = ''

      return
    }

    state.images.interior = payload.Interior
    state.images.exterior = payload.Exterior
    state.images.extRear = payload.ExtRear
    state.images.extSide = payload.ExtSide
    state.images.intBoot = payload.IntBoot
    state.images.intSide = payload.IntSide
  },
  setIsUpdating: (state, payload) => {
    state.isUpdating = payload
  },
  setIsKomNumberUpdating: (state, payload) => {
    state.isKomNumberUpdating = payload
  },
}

const actions = {
  setPrices: ({ commit }, payload) => {
    commit('setNetCatalogPrice', payload.NetCatalogPrice)
    commit('setPrice', payload.Price)
  },
  resetConfiguration: ({ commit }) => {
    commit('setConfiguration', null)
    commit('setConfigurationCode', '')
    commit('setKomNumber', '')
    commit('setPrice', null)
    commit('setNetCatalogPrice', null)
    commit('setImages', null)
  },
  getConfiguration: ({ commit, dispatch }, payload) => {
    return ConfigurationApi.getConfiguration(
      payload.configurationCode,
      payload.deliveryDate,
      payload.calculateBpm
    )
      .then((response) => {
        payload.response = response
        dispatch('setAfterGetConfiguration', payload)

        return Promise.resolve(response)
      })
      .catch((e) => {
        if (axios.isCancel(e)) {
          return
        }
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  setAfterGetConfiguration({ commit, dispatch }, payload) {
    const response = payload.response
    if (response.HasFuturePrice) {
      EventBus.$emit('notification-warning', 'HasFuturePriceWarning')
    }
    commit('setConfigurationCode', payload.configurationCode)
    commit('setConfiguration', response)
    commit('setKomNumber', '')
    commit('setImages', response.Images)
    dispatch('setPrices', response)
  },
  getStockcar: ({ commit, dispatch }, payload) => {
    commit('setLoading', true)
    return ConfigurationApi.getStockcar(
      payload.stockCarId,
      payload.deliveryDate,
      payload.calculateBpm
    )
      .then(
        (response) => {
          commit('setKomNumber', response.StockCarDetails.KomNumber.Number)
          commit('setConfiguration', response.Configuration)
          commit('setStockCarDetails', response.StockCarDetails)
          commit('setStockCarId', payload.stockCarId)
          commit('setImages', response.Configuration.Images)
          dispatch('setPrices', response.Configuration)
          return Promise.resolve(response)
        },
        (error) => {
          if (error.response.status === 404) {
            return
          }
        }
      )
      .catch((e) => {
        if (axios.isCancel(e)) {
          return
        }
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  getNewStock: ({ commit, dispatch }, payload) => {
    commit('setLoading', true)

    return ConfigurationApi.getStock(payload.stockId, payload.deliveryDate, payload.calculateBpm)
      .then(
        (response) => {
          commit('setKomNumber', response.CommissionNumber)
          commit('setConfiguration', response.Configuration)
          commit('setStockCarDetails', response.StockCarDetails)
          commit('setStockCarId', payload.stockCarId)
          commit('setImages', response.Configuration.Images)
          dispatch('setPrices', response.Configuration)
          return Promise.resolve(response)
        },
        (error) => {
          if (error.response.status === 404) {
            return
          }
        }
      )
      .catch((e) => {
        if (axios.isCancel(e)) {
          return
        }
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  setIsKomNumberUpdating: ({ commit }, payload) => {
    commit('setIsKomNumberUpdating', payload)
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
